module.exports = __webpack_public_path__ + "assets/fs-quanbudingdan.0ffcd416.svg";